import styled from 'styled-components';

export const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    border: '1px solid #E0E0E0',
    boxShadow: 'none',
  },
  table: {},
  tableWrapper: {
    overflowX: 'auto',
  },
});

export const ProgressWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.25rem;
`;
